import { useParams } from '@reach/router';
import BannerContent from './Content';
import BannerSidebar from './Sidebar';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { t } from 'i18next';
import { useClient } from 'jsonapi-react';

export default function BannerForm() {
  const { id } = useParams();
  const client = useClient();
  const [isEditing, setIsEditing] = useState(false);
  const [bannerDetails, setBannerDetails] = useState(null);

  const getBannerDetails = async () => {
    try {
      const { data, error } = await client.fetch(`/bulletin_boards/${id}`);
      if (error) {
        toast.error(t('bulletinBoards.errorFetchingBannerDetails'));
      } else {
        setBannerDetails(data);
      }
    } catch (error) {
      toast.error(t('bulletinBoards.errorFetchingBannerDetails'));
      console.error(error);
    }
  };

  useEffect(() => {
    if (id) {
      getBannerDetails();
      setIsEditing(true);
    }
  }, [id]);

  return (
    <div className="main-screen">
      <BannerSidebar />
      <main className="main-content">
        <BannerContent
          isEditing={isEditing}
          bannerData={bannerDetails}
        />
      </main>
    </div>
  );
}
